import { render } from "./usable_text.vue?vue&type=template&id=79175532"
import script from "./usable_text.vue?vue&type=script&lang=js"
export * from "./usable_text.vue?vue&type=script&lang=js"

import exportComponent from "/vuebuild/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__